import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { RoleLandingRedirectGuard } from './guards/role-landing-redirect.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/loginform',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/dashboard/dashboard').then(m => m.DashboardPage),
  },
  {
    path: 'projects',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/project/project-list/project-list.page').then(m => m.ProjectListPage),
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./pages/project/project-create-edit/project-create-edit.page').then(m => m.ProjectCreateEditPage),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/project/project-detail/project-detail.page').then(
            m => m.ProjectDetailPage
          ),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./pages/project/project-create-edit/project-create-edit.page').then(m => m.ProjectCreateEditPage),
      },
      {
        path: ':projectId/create-trial',
        loadComponent: () =>
          import('./pages/trial/trial-create-edit/trial-create-edit.page').then(m => m.TrialCreateEditPage),
      }
    ],
  },
  {
    path: 'bluetooth',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/bluetooth/bluetooth').then(m => m.BluetoothPage),
  },
  {
    path: 'account',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/account/account.page').then(m => m.AccountPage),
  },
  {
    path: 'guidance-information',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/guidance-information/guidance-information.page').then(m => m.GuidanceInformationPage),
      }
    ],
  },
  {
    path: 'login',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/login-form/login-form.page').then(m => m.LoginFormPage),
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./pages/signup/signup').then(m => m.SignupPage),
  },
  {
    path: 'device-info-component',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/device-info/device-info.page').then(m => m.DeviceInfoComponent),
      }
    ],
  },
  {
    path: 'endclients',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/organization/organization-list/organization-list.page').then(m => m.OrganizationListPage),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/organization/organization-detail/organization-detail.page').then(
            m => m.OrganizationDetailPage
          ),
      },
      {
        path: ':id/users',
        loadComponent: () =>
          import('./pages/organization/organization-users/organization-users.page').then(
            m => m.OrganizationUsersPage
          ),
      },
      {
        path: ':clientId/users/create',
        loadComponent: () =>
          import('./pages/organization/organization-users-create-edit/organization-users-create-edit.page').then(
            m => m.OrganizationUsersCreateEditPage
          ),
      },
      {
        path: ':clientId/users/:id/edit',
        loadComponent: () =>
          import('./pages/organization/organization-users-create-edit/organization-users-create-edit.page').then(
            m => m.OrganizationUsersCreateEditPage
          ),
      },
    ],
  },
  {
    path: 'distributors',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/distributor/distributor-list/distributor-list.page').then(m => m.DistributorListPage),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/distributor/distributor-detail/distributor-detail.page').then(
            m => m.DistributorDetailPage
          ),
      },
    ],
  },
  {
    path: 'devices-provision',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/provision/provision.page').then(m => m.ProvisionPage),
      },
      {
        path: 'assign',
        loadComponent: () =>
          import('./pages/assign-device/assign-device.page').then(m => m.AssignDevicePage),
      }
    ],
  },
  {
    path: 'devices-earmark',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/earmark/earmark.page').then(m => m.EarmarkPage),
      },
      {
        path: 'assign',
        loadComponent: () =>
          import('./pages/assign-device/assign-device.page').then(m => m.AssignDevicePage),
      }
    ],
  },
  {
    path: 'users',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/users/users.page').then(m => m.UsersPage),
      }
    ],
  },
  {
    path: 'devices',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/devices/devices.page').then(m => m.DevicesPage),
      }
    ],
  },
  {
    path: 'trials',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/trial/trial-list/trial-list.page').then(m => m.TrialListPage),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/trial/trial-detail/trial-detail.page').then(
            m => m.TrialDetailPage
          ),
        },
      {
        path: 'create',
        loadComponent: () =>
          import('./pages/trial/trial-create-edit/trial-create-edit.page').then(m => m.TrialCreateEditPage),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./pages/trial/trial-create-edit/trial-create-edit.page').then(m => m.TrialCreateEditPage),
      },
      {
        path: ':id/notes/new',
        loadComponent: () =>
          import('./pages/trial/trial-note-editor/trial-note-editor.page').then(
            m => m.TrialNoteEditorPage
          ),
      },
      {
        path: ':id/notes/:noteId',
        loadComponent: () =>
          import('./pages/trial/trial-note-editor/trial-note-editor.page').then(
            m => m.TrialNoteEditorPage
          ),
      },
    ],
  },
  {
    path: 'groups',
    children: [
      {
        path: 'create',
        loadComponent: () =>
          import('./pages/group/group-create-edit/group-create-edit.page').then(m => m.GroupCreateEditPage),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./pages/group/group-create-edit/group-create-edit.page').then(m => m.GroupCreateEditPage),
      },
    ]
  },
  {
    path: 'groupDetail',
    children: [
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/group-detail/group-detail.page').then(
            m => m.GroupDetailPage
          ),
      },
    ],
  },
  {
    path: 'addDevice',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/add-device/add-device.page').then(
            m => m.AddDevicePage
          ),
      },
    ],
  },
  {
    path: 'replaceDevice',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/replace-device/replace-device.page').then(
            m => m.ReplaceDevicePage
          ),
      },
    ],
  },
  {
    path: 'deviceDetail',
    children: [
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/device-detail/device-detail.page').then(
            m => m.DeviceDetailPage
          ),
      },
    ],
  },
  {
    path: 'device-activate',
    loadComponent: () =>
      import('./pages/device-activate/device-activate.page').then(m => m.DeviceActivatePage),
  },
  {
    path: 'install-device',
    loadComponent: () =>
      import('./pages/install-device/install-device.page').then(m => m.InstallDevicePage),
  },
  {
    path: 'connect-probes',
    loadComponent: () =>
      import('./pages/connect-probes/connect-probes.page').then(m => m.ConnectProbesPage),
  },
  {
    path: 'set-location',
    loadComponent: () =>
      import('./pages/set-location/set-location.page').then(m => m.SetLocationPage),
  },
  {
    path: 'metadata-page',
    loadComponent: () =>
      import('./pages/metadata/metadata.page').then(m => m.MetadataPage),
  },
  {
    path: 'switch-account',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/switch-account/switch-account.page').then(m => m.SwitchAccountPage),
  },
  {
    path: '**',
    canActivate: [RoleLandingRedirectGuard],
    loadComponent: () => import('./pages/dashboard/dashboard').then(m => m.DashboardPage),
  }
];
